import { useEffect, useState } from "react";

export function ProfileInput({ label, value, onChange, hint }) {
  const [display, setDisplay] = useState(value === 0 ? "" : String(value));

  function handleChange(e) {
    const raw = e.target.value;
    // allow digits and a single decimal point only
    if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
      setDisplay(raw);
    }
  }

  function handleBlur() {
    const num = parseFloat(display);
    if (!isNaN(num)) {
      onChange(num);
      setDisplay(String(num));
    } else {
      // reset to last valid value if user left it empty/invalid
      setDisplay(value === 0 ? "" : String(value));
    }
  }
  useEffect(() => {
    setDisplay(value === 0 ? "" : String(value));
  }, [value]);
  return (
    <div className="flex flex-col gap-1">
      <label className="text-[8px] uppercase tracking-wider text-brand-dim font-bold">
        {label}
      </label>
      <input
        type="text"
        inputMode="decimal"
        value={display}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="0"
        className="bg-brand-bg border border-brand-border rounded px-3 py-2 text-sm
                   text-brand-text outline-none focus:border-brand-green transition-colors
                   placeholder-brand-dim/40"
      />
      {hint && (
        <span className="text-[8px] text-gray-600 ml-0.5">{hint}</span>
      )}
    </div>
  );
}
